export default __webpack_public_path__ + "static/media/Flowair.4abe3d02.mp4";